import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
  import Pagination from '@/components/common/Pagination.vue'
  import PlaceholderShimmer from '@/components/common/PlaceholderShimmer.vue'
  import AuthorAudioSection from '@/components/course/AuthorAudioSection.vue'
  import useBreakpoint from '@/composables/useBreakpoint'
  import VideoOrImageRenderer from '@/components/course/VideoOrImageRenderer.vue'
  import Dropdown from '@/components/common/Dropdown.vue'
  import VideoTranscript from '@/components/course/VideoTranscript.vue'
  import HTMLRenderer from '@/components/common/HTMLRenderer.vue'
  import eventBus from '@/main'
  import type { PropType } from 'vue'
  import type { Slideshow } from '@/services/interfaces/Course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LessonSlideshow',
  props: {
    slides: {
      type: Array as PropType<Slideshow[]>,
      required: true,
    },
    onePager: {
      type: Boolean,
      default: false,
    },
    formatContent: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props) {

const props = __props;

  

  const currentPage = ref(1)

  const dropdownItems = computed(() => {
    return props.slides.map((slide, index) => ({
      type: index,
      title: slide.title,
      selectable: true,
    }))
  })

  const currentSlide = computed(() => props.slides[currentPage.value - 1])

  const content = computed(() => {
    const data = {
      key: currentPage.value,
      slides: [currentSlide.value],
    }
    if (props.onePager) {
      data.slides = props.slides
    }
    return data
  })

  const hasSlides = computed(() => !!content.value.slides && content.value.slides.length > 0)

  const { current } = useBreakpoint()
  const zoomIn = (pageNumber: number) => {
    if (['xxl', 'xxxl'].includes(current.value)) {
      eventBus.$emit('show-modal', {
        modalContentComponent: 'LessonSlideshowModal',
        modalProps: {
          slides: props.slides,
          pageNumber,
        },
        cssClass: 'slideshow-modal',
        modalCloseCallback: (callback: () => void) => {
          if (typeof callback === 'function') callback()
        },
      })
    }
  }

return { __sfc: true,props, currentPage, dropdownItems, currentSlide, content, hasSlides, current, zoomIn, computed, ref, Pagination, PlaceholderShimmer, AuthorAudioSection, useBreakpoint, VideoOrImageRenderer, Dropdown, VideoTranscript, HTMLRenderer, eventBus }
}

})